<script setup>
  defineProps({
    name: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <span class="material-symbols-outlined">
    {{ name }}
  </span>
</template>
